import { interopDefault } from '~/router/utils'
import { getParkingRoutes } from '~/router/routes/car/account/parking'
import { RouteConfig } from 'vue-router'
import wantedPartsRoutes from '~/router/routes/car/wanted-parts'

/**
 *
 * @param basePath
 */
export function getAccountRoutes(
  basePath: string,
  parkingPath: string = 'parking',
  notSharedChildren: any[]
): RouteConfig[] {
  return [
    {
      name: '__account',
      path: basePath,
      component: () =>
        interopDefault(
          import(
            '~/pages/account/index.vue' /* webpackChunkName: "pages-account-index.vue" */
          )
        ),
      meta: {
        scrollTopSmooth: true
      },
      children: [
        {
          path: 'overview/',
          name: '__account_overview',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/overview.vue' /* webpackChunkName: "pages-account-overview.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          }
        },
        {
          path: 'announcements/:id/',
          name: '__account_announcements_view',
          meta: { scrollTopSmooth: true },
          component: () =>
            interopDefault(
              import(
                '~/pages/account/announcements/view.vue' /* webpackChunkName: "pages-account-view.vue" */
              )
            )
        },
        {
          path: 'tickets/',
          name: '__account_tickets',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/tickets/list.vue' /* webpackChunkName: "pages-account-tickets-list.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          }
        },
        {
          path: 'offers/',
          name: '__account_offers',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/offers/index.vue' /* webpackChunkName: "pages-account-offers-index.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          redirect: { name: '__account_offers_other_classifieds' },
          children: [
            {
              path: 'my-classifieds/',
              name: '__account_offers_my_classifieds',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/offers/my-classifieds.vue' /* webpackChunkName: "pages-account-offers-my-classifieds.vue" */
                  )
                )
            },
            {
              path: 'other-classifieds/',
              name: '__account_offers_other_classifieds',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/offers/other-classifieds.vue' /* webpackChunkName: "pages-account-offers-other-classifieds.sent" */
                  )
                )
            }
          ]
        },
        {
          path: 'tickets/:id/',
          name: '__account_tickets_view',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/tickets/view.vue' /* webpackChunkName: "pages-account-tickets-list.vue" */
              )
            )
        },
        {
          path: 'statistics/',
          name: '__account_statistics',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/statistics/index.vue' /* webpackChunkName: "pages-account-statistics-index.vue" */
              )
            ),
          redirect: { name: '__account_statistics_overview' },
          meta: {
            scrollTopSmooth: true
          },
          children: [
            {
              path: 'overview/',
              name: '__account_statistics_overview',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/analytics/overview.vue' /* webpackChunkName: "pages-analytics-overview.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'market/',
              name: '__account_statistics_market',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/analytics/market.vue' /* webpackChunkName: "pages-analytics-market.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'classifieds/',
              name: '__account_statistics_classifieds',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/analytics/classifieds/index.vue' /* webpackChunkName: "pages-analytics-classifieds.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            }
          ]
        },
        {
          path: 'searches/',
          name: '__account_searches',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/searches/index.vue' /* webpackChunkName: "pages-account-parking-searches-index.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          redirect: { name: '__account_searches_favorite' },
          children: [
            {
              path: 'favorite/',
              name: '__account_searches_favorite',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/searches/favorite.vue' /* webpackChunkName: "pages-account-searches-favorite.vue" */
                  )
                )
            },
            {
              path: 'recent-classifieds/',
              name: '__account_searches_recent_classifieds',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/searches/recent-classifieds.vue' /* webpackChunkName: "pages-account-searches-recent-classifieds.vue" */
                  )
                )
            },

            {
              path: 'recent/',
              name: '__account_searches_recent',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/searches/recent.vue' /* webpackChunkName: "pages-account-searches-recent.vue" */
                  )
                )
            }
          ]
        },
        {
          path: `${parkingPath}/`,
          name: '__account_parking',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/parking/index.vue' /* webpackChunkName: "pages-account-classifieds-index.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          redirect: { name: '__account_parking_classifieds_favorite' },
          children: getParkingRoutes('account')
        },
        {
          path: 'messages/',
          name: '__account_messages',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/messages.vue' /* webpackChunkName: "pages-account-messages.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          children: [
            {
              path: 'inbox/',
              name: '__account_messages_inbox',
              redirect: { name: '__account_messages' }
            }
          ]
        },
        {
          path: 'sale-requests/',
          name: '__account_sale_requests',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/sale-requests/index.vue' /* webpackChunkName: "pages-account-sale-requests-index.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          redirect: { name: '__account_sale_requests_overview' },
          children: [
            {
              path: 'overview/',
              name: '__account_sale_requests_overview',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/sale-requests/overview.vue' /* webpackChunkName: "pages-account-sale-requests-overview.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'request-settings/',
              name: '__account_sale_requests_request_settings',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/sale-requests/request-settings.vue' /* webpackChunkName: "pages-account-sale-requests-request-settings.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'general-settings/',
              name: '__account_sale_requests_general_settings',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/sale-requests/general-settings.vue' /* webpackChunkName: "pages-account-sale-requests-general-settings.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            }
          ]
        },
        {
          path: 'rogue-classifieds/',
          name: '__account_rogue_classifieds',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/rogue-classifieds.vue' /* webpackChunkName: "pages-account-rogue-classifieds.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          }
        },
        {
          path: 'rogue-classifieds/info',
          name: '__account_rogue_classifieds_info',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/rogue-classifieds-info.vue' /* webpackChunkName: "pages-account-rogue-classifieds-info.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          }
        },
        {
          path: 'settings/',
          name: '__account_settings',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/settings/index.vue' /* webpackChunkName: "pages-account-settings-index.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          children: [
            {
              path: 'details/',
              name: '__account_settings_details',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/settings/details.vue' /* webpackChunkName: "pages-account-settings-details.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'dealers/',
              name: '__account_settings_dealers',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/car/account/dealers/index.vue' /* webpackChunkName: "pages-car-account-dealers-index.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              name: '__account_settings_dealers_edit',
              path: 'dealers/:dealerId/edit/',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/car/account/dealers/edit.vue' /* webpackChunkName: "pages-dealers-edit.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'manager-invoices/',
              name: '__account_settings_manager_invoices',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/settings/manager-invoices.vue' /* webpackChunkName: "pages-account-settings-manager-invoices.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'security/',
              name: '__account_settings_security',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/settings/security.vue' /* webpackChunkName: "pages-account-settings-security.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'email-change/',
              name: '__account_settings_email_change',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/settings/email-change.vue' /* webpackChunkName: "pages-account-settings-email-change.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'invoicing-details/',
              name: '__account_settings_invoicing_details',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/settings/invoicing-details.vue' /* webpackChunkName: "pages-account-settings-invoicing-details.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'payments/',
              name: '__account_settings_payments',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/settings/payments/index.vue' /* webpackChunkName: "pages-account-settings-payments-index.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              },
              redirect: { name: '__account_settings_payments_overview' },
              children: [
                {
                  path: 'overview/',
                  name: '__account_settings_payments_overview',
                  component: () =>
                    interopDefault(
                      import(
                        '~/pages/account/settings/payments/overview.vue' /* webpackChunkName: "pages-account-settings-payments-overview.vue" */
                      )
                    ),
                  meta: {
                    scrollTopSmooth: true
                  }
                },
                {
                  path: 'success/',
                  name: '__account_settings_payments_success',
                  component: () =>
                    interopDefault(
                      import(
                        '~/pages/account/settings/payments/success.vue' /* webpackChunkName: "pages-account-settings-payments-success.vue" */
                      )
                    ),
                  meta: {
                    scrollTopSmooth: true
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'subscriptions/',
          name: '__account_subscriptions',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/subscriptions.vue' /* webpackChunkName: "pages-account-subscriptions.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          }
        },
        {
          path: 'credits/',
          name: '__account_credits',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/credits/index.vue' /* webpackChunkName: "pages-account-credits-index.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          redirect: { name: '__account_credits_buy' },
          children: [
            {
              path: 'buy/',
              name: '__account_credits_buy',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/credits/buy-credits.vue' /* webpackChunkName: "pages-account-buy-credits.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'spending-history/',
              name: '__account_credits_spending_history',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/credits/credits-spending-history.vue' /* webpackChunkName: "pages-account-credits-spending-history.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            }
          ]
        },
        {
          path: 'notifications/',
          name: '__account_notifications',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/notifications/index.vue' /* webpackChunkName: "pages-account-notifications-index.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          },
          redirect: { name: '__account_notifications_list' },
          children: [
            {
              path: 'list/',
              name: '__account_notifications_list',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/notifications/list.vue' /* webpackChunkName: "pages-account-notifications-list.vue" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            },
            {
              path: 'settings/',
              name: '__account_notifications_settings',
              component: () =>
                interopDefault(
                  import(
                    '~/pages/account/settings/notifications.vue' /* webpackChunkName: "pages-settings-notifications" */
                  )
                ),
              meta: {
                scrollTopSmooth: true
              }
            }
          ]
        },
        {
          path: 'audits/new',
          name: '__account_audits_new',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/audits/new.vue' /* webpackChunkName: "pages-account-audits-new.vue" */
              )
            )
        },
        {
          path: 'xml',
          name: '__account_xml',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/xml.vue' /* webpackChunkName: "pages-account-xml.vue" */
              )
            )
        },
        ...wantedPartsRoutes,
        {
          path: 'prices-history',
          name: '__account_prices_history',
          component: () =>
            interopDefault(
              import(
                '~/pages/account/subscription-perks/prices-history.vue' /* webpackChunkName: "pages-account-subscription-perks-prices-history.vue" */
              )
            ),
          meta: {
            scrollTopSmooth: true
          }
        },
        ...notSharedChildren
      ]
    }
  ]
}
